export const LOCAL_STORAGE = {
  NAME: "_AppStorage",
  KEY: {
    USER: "USER",
    SITE: "SITE",
    ACCESS_TOKEN: "ACCESS_TOKEN",
    REFRESH_TOKEN: "REFRESH_TOKEN"
  }
}

export const SESSION_STORAGE = {
  NAME: "_AppStorage",
  KEY: {
    TEST: "TEST",
    SITE: "SITE",
  }
}
